<template>
  <div class="background-01">
     <v-layout row wrap>
      <v-flex xs12 sm2 md2 class="hidden-xs-only ">
        <image-app class="animated fadeInLeft" :imaSize="300" imaSrc="design/banco1-1-3" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="Existen diferentes tipos de gastos" titleLevel="h1">
          <template slot="partOne">Existen diferentes<br></template>
          <template slot="partThree"> tipos de gastos</template>
        </ui-title-one>
      </v-flex>
    </v-layout>

    <v-layout row wrap class="animated fadeInUp dura_1">
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'Existen diferentes tipos de gastos'" videoEmbed="ADMINISTRACIONDINERO28DiferentesTiposDeGastosa.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12>
        <p>Pase el cursor o dé enter sobre cada tipo de gasto para descubrir su definición</p>
      </v-flex>      
    </v-layout>
    
    <button-expand-cont class="animated fadeInUp dura_2" :contenidos="contenidos"></button-expand-cont>

  </div>
</template>

<script>
export default {
  data() {
    return {
      contenidos: [
        {
          nombre: 'Gastos fijos',
          texto: `Su valor no cambia con frecuencia y representa en general una <strong>obligación</strong> cuyo pago ha sido acordado de manera previa.<br><br>
          Los pagos de la hipoteca, el arriendo, la pensión escolar, son ejemplos de gastos fijos.`,
          visto: false
        },
        {
          nombre: 'Gastos variables',
          texto: `Son aquellos cuyo valor <strong>puede cambiar</strong> mes a mes. El mercado, las cuentas de los servicios públicos, los gastos de 
          entretenimiento, el costo de la gasolina entre otros, son gastos variables.`,
          visto: false
        },
        {
          nombre: 'Gastos opcionales',
          texto: ` Son los gustos o antojos que <strong>no son necesarios</strong> pero se incurre en ellos para lograr un estilo de vida. 
          Ejemplo: reproductor de música, cine, restaurante de lujo, ropa que no se requiere.`,
          visto: false
        },
      ]
    };
  },
  mounted() {
    this.$store.commit("nextShow", false);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-28.vue?81488ecc